import { hasPermissionFunction } from "src/helper/HasPermission"

export const getTotal = (paymentData) => {
  const type_payment = paymentData?.form_data?.credit_or_payment_type
  if (type_payment == 'CREDIT') {
    return paymentData?.form_data?.credit.reduce((sum, current) => sum + current?.amount_to_pay, 0)
    // Filtrar solo los objetos con name 'net_amount'
    // Sumar los valores de esos objetos
  }
  if (type_payment === 'PAYMENT_TYPE') {
    if(hasPermissionFunction('payment-entity','rule')){
      return paymentData?.form_data?.paymentType
        .map((payment) => payment?.extra_cost)
        .flat()
        .filter((cost) => cost?.name === 'net_amount')
        .reduce((sum, current) => sum + current?.value, 0)
      // Filtrar solo los objetos con name 'net_amount'
      // Sumar los valores de esos objetos
    } else {
      return paymentData?.form_data?.paymentType.reduce((acc, pay) => {
        if(pay.confirmed_total){
          return acc + pay.confirmed_total
        } else{
          return acc
        }
          
      }, 0)
    }
  }
  return 0
}
